var elms = document.getElementsByClassName( 'splide' );


for ( var i = 0; i < elms.length; i++ ) {
  new Splide( elms[ i ] ).mount();
}

$(document).ready(function(){
  $(document).on('click','.add-budle-products',function(){
    var parent = $(this).closest('.bundle-outer'),
        id = '';
    $(this).addClass('loading');
     
    $(parent).find('.bundle-cont').each(function(){
      //$(this).find('.product-form__submit').trigger('click');
      if( $(this).hasClass('last-bundle') == false ){
        var formEasy = $(this).find('form');
        
        var form = formEasy.serialize(),
            id = $(this).find('form [name="id"]').val();
        

        if(id != ''){
          //alert('herer'+id)
          var data = [];
          $.ajax({
              type: 'post',
              url: '/cart/add.js',
              data: form,
              dataType: 'JSON',
              async : false,
              success: function (response) {
                if( $(document).find('.last-bundle form [name="id"]').val() == '' ){
                  this.miniCart = document.querySelector('mini-cart');
                  if (this.miniCart) {
                    console.log('here')
                    this.miniCart.renderContents(response);
                  }
                }
              }
          });
        }
      }
    });
    setTimeout(function(){
      if( $(document).find('.last-bundle form [name="id"]').val() != '' ){
        $(document).find('.last-bundle .product-form__submit').trigger('click');
        
      }
      
      setTimeout(function(){
        $(document).find('.add-budle-products').removeClass('loading');
        $.ajax({
            type: 'get',
            url: '/cart.js',
            dataType: 'JSON',
            async : false,
            success: function (data) {
              
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: id });
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
              document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
            }
        });
        
      },1000);
      
    },2000);
  })
})
